import React, { useState, useEffect } from 'react'
import './styles/settings.scss'
import { CaretLeft } from '@phosphor-icons/react'
import { Button } from 'antd'
import ButtonSpinner from 'components/global/ButtonSpinner'
import { classesEventStore } from 'state/classes/classesStore'
import MentorRequest from './essentialComp/MentorRequest'
import Security from './essentialComp/Security'
import Donation from './essentialComp/Donation'
import Confirmationmodal from '../Step7/Modals/Confirmationmodal'
import { useEditStep8Mutation } from 'api/Classes/Classes'

interface AdditionalClassSettingsProps {
  handleNext: (data: any) => void
  handleBack: () => void
}

const Settings: React.FC<AdditionalClassSettingsProps> = ({
  handleNext,
  handleBack,
}) => {
  const [confirmModal, setConfirmModal] = useState<boolean>(false)
  const { classesData, riskLevel, setClassesData, donationData, setDonationData } = classesEventStore(store => ({
    classesData: store.classesData,
    riskLevel: store.riskLevel,
    setClassesData: store.setClassesData,
    donationData: store.donationData,
    setDonationData: store.setDonationData,
  }))

  const { mutate: step8Mutation, isLoading: step8MutationLoading } = useEditStep8Mutation()

  useEffect(() => {
    setClassesData({
      ...classesData,
      riskLevel: riskLevel,
      allowDonation: donationData.allowDonation,
      preSelectedDonationAmounts: donationData.preSelectedDonationAmounts,
    })
  }, [])

  const handleStep8CompleteClick = () => {
    const payload = {
      security: riskLevel || 'low',
      allowDonation: donationData.allowDonation,
      preSelectedDonationAmounts: donationData.preSelectedDonationAmounts,
    }

    step8Mutation(
      { body: payload, classId: classesData._id },
      {
        onSuccess: data => {
          setClassesData({ ...classesData, ...data })
          setConfirmModal(true)
        },
      },
    )
  }

  return (
    <div className="step3-main-container">
      <div>
        <h3 className="text-24 w-600"> Step 8. Settings</h3>
        <div className="mt-30px overflow-auto-y scroller overflow-hidden-x content-container">
          <div className="mt-20px">
            <MentorRequest />
          </div>
          <div className="mt-20px">
            <Security />
          </div>
          <div className="mt-20px">
            <Donation />
          </div>
        </div>
      </div>

      <div className="mt-15px event-button-cont">
        <h5
          className="flex gap-10px align-center pointer"
          onClick={() => handleBack()}
        >
          <CaretLeft size={20} color="#000" />
          <span className="text-15 w-500">Back</span>
        </h5>
        <Button className="stepper-button" onClick={handleStep8CompleteClick}>
          {step8MutationLoading ? <ButtonSpinner size={20} color="#000" /> : 'Next'}
        </Button>
      </div>

      {confirmModal && (
        <Confirmationmodal
          openModal={confirmModal}
          closeModal={setConfirmModal}
        />
      )}
    </div>
  )
}

export default Settings
